import React, { useContext } from 'react'

import Page from '../../../components/Page'
import HealthPlanReport from '../../../components/sections/reportBuilder/studentForms/HealthPlanReport'
import AuthContext from '../../../utils/authProvider'

const HealthPlanReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'Health Plan Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='Health Plan Report' breadcrumb={breadcrumb}>
        <HealthPlanReport />
      </Page>
    </>
  )
}

export default HealthPlanReportPage
